import { render, staticRenderFns } from "./user_center_buy.vue?vue&type=template&id=da38df2a&scoped=true&"
import script from "./user_center_buy.vue?vue&type=script&lang=js&"
export * from "./user_center_buy.vue?vue&type=script&lang=js&"
import style0 from "./user_center_buy.css?vue&type=style&index=0&id=da38df2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da38df2a",
  null
  
)

export default component.exports